import { Inject, Injectable, Optional } from '@angular/core';
import { BroadcastChannelService } from '@app/core/broadcast-channel/broadcast-channel.service';
import { Subject } from 'rxjs';

declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class DjangoChannelService {
  

  private channel!: BroadcastChannel;

  private djangoChannel: Subject<DjangoChannelEventData> = new Subject<DjangoChannelEventData>();

  constructor(
    @Inject('channelName') @Optional() public channelName: string,
    public broadcastChannelService: BroadcastChannelService
  ) {
    console.log('DjangoChannelService channelName', channelName)
    this.channel = new BroadcastChannel(channelName || 'xrsupport-channel');

    this.channel.onmessage = (event) => {
      console.log('DjangoChannelService onmessage', event)
      this.publishData({
        event: 'djangoChannel',
        data: event.data
      });
    };
   }

   sendData(event: any) {
    // this.channel.postMessage(event);
    this.broadcastChannelService.sendLocalMessage(event);
  }


  publishData(event: DjangoChannelEventData) {
    this.djangoChannel.next(event);
  }

  getObservable() {
    return this.djangoChannel;
  }
}

export interface DjangoChannelEventData {
  event: string;
  data: any;
}
